




import moment, { Moment } from 'moment';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as api from '@/api';

@Component({ components: {} })
export default class TrendChart extends Vue {
  @Prop({ type: Array, required: true }) dateRange!: [Moment, Moment];

  @Watch('dateRange', { deep: true, immediate: true })
  onDateRangeChanged(newVal: [Moment, Moment]) {
    if (newVal) {
      this.setDateAndFetch();
    }
  }

  chartOptions = {};

  listData: any = [];

  listQuery: any = {
    st: null,
    et: null,
    currentStartDate: '',
    startDate: null,
    endDate: null,
    type: '',
  };

  mounted() {
    this.fetchData();
  }

  setTypeAndFetch(type: string) {
    this.listQuery.type = type;
    this.fetchData();
  }

  setDateAndFetch() {
    this.listQuery.st = this.dateRange[0];
    this.listQuery.et = this.dateRange[1];
    this.fetchData();
  }

  async fetchData() {
    const data: any = await api.Yq.getDayStatistics_GET({
      st: this.listQuery.st ? new Date(new Date(new Date(this.listQuery.st).toLocaleDateString()).getTime()) : null,
      et: this.listQuery.et
        ? new Date(new Date(new Date(this.listQuery.et).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
        : null,
      startDate: this.listQuery.type ? this.listQuery.currentStartDate : null,
      endDate: this.listQuery.endDate,
      type: this.listQuery.type,
      city: '',
      county: '',
    });
    this.listData = data.data.result;
    //先清空，避免查询影响
    this.listQuery.currentStartDate = '';
    this.listQuery.currentStartDate = data.data.currentStartDate;
    this.chartOptions = {};

    if (this.listData) {
      this.getChart();
    }
  }

  getWeekDay(date: Date) {
    let week;
    let dateFormat = new Date(moment(date).format('YYYY-MM-DD'));
    if (dateFormat.getDay() == 0) week = '星期日';
    if (dateFormat.getDay() == 1) week = '星期一';
    if (dateFormat.getDay() == 2) week = '星期二';
    if (dateFormat.getDay() == 3) week = '星期三';
    if (dateFormat.getDay() == 4) week = '星期四';
    if (dateFormat.getDay() == 5) week = '星期五';
    if (dateFormat.getDay() == 6) week = '星期六';
    return week;
  }

  getChart() {
    let weeks: any = [];
    let sbyqs: any = [];
    let moons: string[] = [];
    if (this.listData) {
      this.listData.forEach((item: any) => {
        // let week = '';
        sbyqs.push(item.Number);
        moons.push(moment(item.Time).format('MM-DD'));
        // week = this.getWeekDay(item.Time)!;
        // weeks.push(week);
      });
    }

    let template = {
      chart: {
        type: 'area', // 折线图
        backgroundColor: 'transparent', // 整体背景透
      },
      title: {
        text: null,
        style: { color: '#fff' },
      },
      xAxis: {
        //自定义x轴
        categories: moons,
        labels: {
          style: {
            color: '#ccc', // 这里设置字体颜色
            fontSize: '14px',
          },
        },
      },
      yAxis: {
        title: { text: '数量(条)' },
        allowDecimals: false,
      },
      credits: {
        //去掉水印
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        area: {
          // 注意这里要是 area
          dataLabels: {
            enabled: true, // 显示点上的数值
            style: { color: '#0bf9fe', fontWeight: 'bold', fontSize: '14px' },
          },
          marker: { enabled: true, radius: 4 }, // 显示点
        },
      },
      series: [
        {
          name: '舆情',
          data: sbyqs,
          color: '#2d8cf0',
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, 'rgba(45,140,240,0.5)'], // 顶部颜色（半透明）
              [1, 'rgba(45,140,240,0)'], // 底部颜色透明
            ],
          },
        },
      ],
    };
    this.chartOptions = template;
  }
}
